
define('template!sdsAddressInputPrompt',['directive!sdcIsLoading'],function(template){return '<div ng-transclude ng-click="vm.EnableManualInput()" sdc-is-loading="vm.EnableManualInputActivity" tabindex="-1"></div>';});

